export default __webpack_public_path__ + "static/assets/med_pill_square_in_L1_solid_l_01_f_mask.df209db5.png";